module.exports = __webpack_public_path__ + "static/media/enfant-absent.ce5ac662.svg";